import * as React from 'react';
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Iconify from '../iconify';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import Stack from '@mui/material/Stack';
import SteLib from 'src/lib/stelib';
import 'dayjs/locale/it';
import { FormControlLabel, Switch } from '@mui/material';

export default function CreateMovieBookingPopup({setOpenEdit, openEdit, setEditData, editData, movieId, successCallback}) {
  const [open, setOpen] = React.useState(false);

  const initData = {
    movieId: undefined,
    dateTime: undefined,
    bookable: false
  }

  const [formData, setFormData] = React.useState(initData);

  const [formSubmitted, setFormSubmitted] = React.useState(false);

  useEffect(() => {
    if(openEdit === true)
    {
      handleEditOpen();
      if(editData !== undefined)
      {
        setFormData(editData)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openEdit])

  useEffect(() => {
    if(open)
    {
      if(movieId > 0)
      {
        setFormData({...formData, movieId: movieId});
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  const handleEditOpen = () => {
    setOpenEdit(false);
    handleClickOpen();
    setOpen(true);
  };
  
  const handleClickOpen = () => {
    setFormData(initData);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditData(undefined);
    setFormSubmitted(false);
  };

  const handleSave = () => {
    setFormSubmitted(true);
    if(formData.movieId > 0 &&
       !dateNotValid(formData.dateTime, true)
    )
    {
      let d = new Date(Date.parse(formData.dateTime));
      formData.dateTime = d.getFullYear()+'-'+(d.getMonth() + 1)+'-'+d.getDate()+'T'+d.getHours()+':'+d.getMinutes()+':00';
      //PUT
      if(editData !== undefined)
      {
        /*SteLib.PutRequest("timetables/"+formData.id, formData, false).then((data) => {
          handleClose();
          successCallback();
        });*/
      }
      else //POST
      {
        SteLib.PostRequest("timetables", formData, false).then((data) => {
          handleClose();
          successCallback();
        });
      }
    }
    else
    {
    }
  };

  let fieldNotValid = (field, ignoreFormSubmitted = false) => {
    let fSub = ignoreFormSubmitted ? true : formSubmitted;
    return (field === "" || field === undefined || field === null) && fSub;
  }

  let dateNotValid = (date) => {
    if (typeof date === 'string')
    {
      date = Date.parse(date);
    }
    return isNaN(date);
  }

  return (
    <div>
      <Button variant="contained" onClick={handleClickOpen} startIcon={<Iconify icon="eva:plus-fill" />}>
        Aggiungi proiezione
      </Button>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle>{editData !== undefined && editData.id > 0 ? "Modifica Proiezione" : "Nuova proiezione"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Inserisci i dati della proiezione per il film 
          </DialogContentText>
          <Stack spacing={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                <DateTimePicker
                  sx={{marginTop: "2rem"}}
                  views={['day', 'month', 'year','hours', 'minutes']}
                  label="Data e Ora"
                  value={formData.dateTime}
                  onChange={(newValue) => {
                    setFormData({...formData, dateTime: newValue})
                  }}
                  renderInput={(params) => <TextField variant='standard' {...params} 
                  error={fieldNotValid(formData.dateTime) || dateNotValid(formData.dateTime)} 
                  />}
                />
              </LocalizationProvider>
              <FormControlLabel control={<Switch />} 
                  onChange={(newValue) => {
                    setFormData({...formData, bookable: newValue.target.checked})
                  }} label="Consenti prenotazione posti" />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annulla</Button>
          <Button onClick={handleSave}>Salva</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}